import { boolean } from "../types/boolean";

export default function or(a, b) {
  a = boolean(a);
  b = boolean(b);
  return a || b;
}
